import classNames from 'classnames';
import React, { FunctionComponent, useState } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from '../AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';
import { Login } from '../AtlassianAccountOnboardingOverlay';

const format = forNamespace(['aa onboarding', 'dialog'], {
  shouldEscapeStrings: false,
});
const DEFAULT_NUM_EMAILS_DISPLAYED = 4;

interface NotWorkProps {
  aaEmail: string;
  otherLogins: Login[];
  orgName: string;
  onClickGoBack: () => void;
  onDismiss: () => void;
  onClickContiniue: () => void;
}

export const WorkAndOtherV2: FunctionComponent<NotWorkProps> = ({
  aaEmail,
  otherLogins,
  orgName,
  onClickGoBack,
  onDismiss,
  onClickContiniue,
}) => {
  const [emailExpanded, setEmailExpanded] = useState(false);
  const emailsToRemove = otherLogins.length > 0;

  return (
    <OnboardingDialog
      onClickGoBack={onClickGoBack}
      title={format('join your organization')}
      helpLink={AtlassianAccountOnboardingLinks.Help}
      closeDialog={onDismiss}
      className={classNames(styles.workAndOtherBody, {
        [styles.extraTopMargin]: !otherLogins.length,
      })}
    >
      <div
        className={classNames(styles.workAndOtherContent, {
          [styles.extraEmailContainer]: otherLogins.length,
        })}
      >
        <section>
          <p>
            {format('after joining')}
            <b>{` ${aaEmail} `}</b>
          </p>
          <p>{format('org admin msg', { org: orgName })}</p>
          <p>{emailsToRemove && format('emails to be removed')}</p>
        </section>
        {emailsToRemove && (
          <div className={styles.multiEmailContainer}>
            {otherLogins.map((login, i) => {
              if (
                (!emailExpanded && i < DEFAULT_NUM_EMAILS_DISPLAYED) ||
                emailExpanded
              ) {
                return (
                  <div key={i} className={styles.multiEmail}>
                    {' '}
                    {login.email}{' '}
                  </div>
                );
              }
            })}
          </div>
        )}
        {otherLogins.length > 4 && !emailExpanded ? (
          <button
            className={styles.showMultiEmailButton}
            onClick={() => setEmailExpanded(true)}
          >
            {format('show all emails button', {
              emailCount: otherLogins.length - DEFAULT_NUM_EMAILS_DISPLAYED,
            })}
          </button>
        ) : null}
      </div>
      <div className={styles.section}>
        <PrimaryButton onClick={onClickContiniue}>
          {format('continue')}
        </PrimaryButton>
      </div>
    </OnboardingDialog>
  );
};
